﻿import { queries } from "@/graphql";
import { useQuery } from "@apollo/client/react";
import { enqueueSnackbar } from "notistack";
import { useEffect } from "react";

/**
 * Custom hook to fetch a deal by its ID.
 * @param {string} id - The ID of the deal to be fetched.
 * @returns {{dealRow: object, loading: boolean}} - The fetched deal data and the loading state.
 */
export function useDealById(id: string) {
  const { data, loading, error } = useQuery<any>(queries.getDealById, {
    variables: { id },
    errorPolicy: "all",
  });

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
    }
  }, [error]);

  return {
    dealRow: data?.getDealById || [],
    loading,
  };
}
